module.exports = __webpack_public_path__ + "static/media/smallRabbits_800.8946a75d.png";